import { createIcon } from '@chakra-ui/icons';

export const GenericFile = createIcon({
  displayName: 'GenericFile',
  viewBox: '0 0 16 16',
  path: [
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12.6667 2H3.33333C2.59695 2 2 2.59695 2 3.33333V12.6667C2 13.4031 2.59695 14 3.33333 14H12.6667C13.4031 14 14 13.4031 14 12.6667V3.33333C14 2.59695 13.4031 2 12.6667 2Z"
        stroke="currentColor"
        strokeWidth="1.7"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
      <path
        d="M5.33325 8H10.6666"
        stroke="currentColor"
        strokeWidth="1.7"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
      <path
        d="M5.33325 5.33334H5.33992"
        stroke="currentColor"
        strokeWidth="1.7"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
      <path
        d="M5.33325 10.6667H7.99992"
        stroke="currentColor"
        strokeWidth="1.7"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
    </svg>,
  ],
});
